import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const ONIRVA_ICON = "https://customer-assets.emergentagent.com/job_200ec0e0-0820-4417-b1b5-b6286eb18bc4/artifacts/c3nyk9fu_80AC8250-CA42-4BF9-BA0D-F1211AA6A764.png";

export default function Onboarding() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to profile page with onboarding flag
    navigate('/profile', { state: { onboarding: true }, replace: true });
  }, [navigate]);
  
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <img src={ONIRVA_ICON} alt="ONIRVA" className="w-16 h-16 mx-auto mb-4 rounded-2xl animate-pulse" />
        <Loader2 className="w-6 h-6 animate-spin mx-auto text-primary" />
        <p className="text-muted-foreground mt-4">Setting up your profile...</p>
      </div>
    </div>
  );
}
